/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_S4Inputs */

const en_tut_proyek_s4 = /** @type {(inputs: Tut_Proyek_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the filters and sorting you use daily, then save it as a view. Your layout choice is remembered per page.`)
};

const id_tut_proyek_s4 = /** @type {(inputs: Tut_Proyek_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setel filter dan urutan yang Anda pakai tiap hari, lalu simpan sebagai tampilan. Pilihan tampilan diingat per halaman.`)
};

/**
* | output |
* | --- |
* | "Set the filters and sorting you use daily, then save it as a view. Your layout choice is remembered per page." |
*
* @param {Tut_Proyek_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_s4 = /** @type {((inputs?: Tut_Proyek_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_s4(inputs)
	return en_tut_proyek_s4(inputs)
});